module.exports = __webpack_public_path__ + "img/mobileCoin.3a380c6d.png";